__turbopack_context__.v({
  "full-width": "style-module-scss-module__d4DsTW__full-width",
  "icon-blue": "style-module-scss-module__d4DsTW__icon-blue",
  "icon-green": "style-module-scss-module__d4DsTW__icon-green",
  "icon-purple": "style-module-scss-module__d4DsTW__icon-purple",
  "icon-sky": "style-module-scss-module__d4DsTW__icon-sky",
  "listing-stats-bar": "style-module-scss-module__d4DsTW__listing-stats-bar",
  "listing-stats-track": "style-module-scss-module__d4DsTW__listing-stats-track",
  "more-stats-arrow": "style-module-scss-module__d4DsTW__more-stats-arrow",
  "more-stats-card": "style-module-scss-module__d4DsTW__more-stats-card",
  "more-stats-label": "style-module-scss-module__d4DsTW__more-stats-label",
  "stat-card": "style-module-scss-module__d4DsTW__stat-card",
  "stat-icon": "style-module-scss-module__d4DsTW__stat-icon",
  "stat-label": "style-module-scss-module__d4DsTW__stat-label",
  "stat-text": "style-module-scss-module__d4DsTW__stat-text",
  "stat-value": "style-module-scss-module__d4DsTW__stat-value",
});
